<template>
  <video class="video" :class="classCss" controls>
    <source :src="src" :type="type" />
  </video>
</template>

<script>
export default {
  props: {
    classCss: {
      required: false
    },
    src: {
      required: true
    },
    type: {
      required: true
    }
  }
};
</script>
